export function config($stateProvider) {
  $stateProvider.state('index.customercare.customer.billingpayments.creditNote', {
    url: '/creditDetails/:creditNoteId',
    template: '<credit-note-details></credit-note-details>'
  });
}